import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import * as dotenv from 'dotenv';
import { Layout } from './components/Layout';
import { AppContext } from './AppContext';
import { Home } from './components/Home';
//import { FormularioAlumni } from './components/Formulario';
//import { FormularioAlumniTabs } from './components/FormularioTabs';
//import { FormularioTabsNew } from './components/FormularioTabsNew';
import { MiniFormulario } from './components/MiniFormulario';
import { FormularioAlumni } from './components/FormularioAlumni';
import { DownloadReport } from './components/DownloadReport';
import { Aviso } from './components/Aviso';

import './custom.css';

// PARA LA DESCARGA DE REPORTE
import { createBrowserHistory } from 'history';
import { authService } from './services/auth.service';
import CasClient, { constant } from "react-cas-client";
const history = createBrowserHistory();
const [CAS_PROTOCOL, CAS_SERVER] = (process.env.REACT_APP_CAS_URL).split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PROTOCOL };
const casClient = new CasClient(CAS_SERVER, casOptions);

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <>
                <Layout>
                    <Switch>
                        <Route exact path='/' component={FormularioAlumni} />
                        <Route path='/aviso-privacidad' component={Aviso} />
                        <Route path='/reporte' component={DownloadReport} />
                        <Route path='/actualizacion-datos' component={MiniFormulario} />
                    </Switch>
                </Layout>

                {/*<AppContext.Provider value={this.state.currentUser}>*/}
                {/*</AppContext.Provider>*/}
            </>
        );
    }
}
